/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booster_Pack_SInputs */

const en_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small Pack`)
};

const ar_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزمة صغيرة`)
};

const de_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleines Paket`)
};

const es_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack pequeño`)
};

const fr_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petit pack`)
};

const it_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetto piccolo`)
};

const ja_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スモールパック`)
};

const ko_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소형 패키지`)
};

const pt_br_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacote pequeno`)
};

const ru_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Малый пакет`)
};

const th_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็คเล็ก`)
};

const tr_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küçük paket`)
};

const zh_cn_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小礼包`)
};

const zh_tw_booster_pack_s = /** @type {(inputs: Booster_Pack_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小禮包`)
};

/**
* | output |
* | --- |
* | "Small Pack" |
*
* @param {Booster_Pack_SInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const booster_pack_s = /** @type {((inputs?: Booster_Pack_SInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booster_Pack_SInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booster_pack_s(inputs)
	if (locale === "ar") return ar_booster_pack_s(inputs)
	if (locale === "de") return de_booster_pack_s(inputs)
	if (locale === "es") return es_booster_pack_s(inputs)
	if (locale === "fr") return fr_booster_pack_s(inputs)
	if (locale === "it") return it_booster_pack_s(inputs)
	if (locale === "ja") return ja_booster_pack_s(inputs)
	if (locale === "ko") return ko_booster_pack_s(inputs)
	if (locale === "pt_br") return pt_br_booster_pack_s(inputs)
	if (locale === "ru") return ru_booster_pack_s(inputs)
	if (locale === "th") return th_booster_pack_s(inputs)
	if (locale === "tr") return tr_booster_pack_s(inputs)
	if (locale === "zh_cn") return zh_cn_booster_pack_s(inputs)
	return zh_tw_booster_pack_s(inputs)
});